enum EnumReferralRewardType {
  Days = 0,
  Month = 1,
  Year = 2,
  Lifetime = 3,
}

export default EnumReferralRewardType;
